import axios, { type AxiosInstance, type AxiosResponse, type AxiosError } from 'axios'
import { requestInterceptor } from './interceptors/requestInterceptor'
import { responseInterceptor } from './interceptors/responseInterceptor'

export const createHttpClient = (): AxiosInstance => {
  const baseURL = import.meta.env.VITE_API_URL || 'https://jp-core-api-dev.azurewebsites.net/api/v1'
  
  const client = axios.create({
    baseURL,
    timeout: 90000, // 90 seconds timeout for long-running operations like AI generation
    headers: {
      'Content-Type': 'application/json',
    },
  })

  client.interceptors.request.use(requestInterceptor[0], requestInterceptor[1])
  client.interceptors.response.use(
    responseInterceptor[0] as (value: AxiosResponse<unknown, unknown>) => AxiosResponse<unknown, unknown> | Promise<AxiosResponse<unknown, unknown>>,
    responseInterceptor[1] as (error: AxiosError<unknown, unknown>) => Promise<never>
  )

  return client
}

export const httpClient = createHttpClient()